<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div class="field" [ngClass]="displayFieldCss('rcNumber')">
        <label>RC Number </label>
        <input formControlName="rcNumber" type="text" placeholder="RC Number" />
        <app-field-error-display
          [displayError]="isFieldValid('rcNumber')"
          errorMsg="Please company RC number"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('dateOfRegistration')">
        <label>Registration Date</label>
        <input
          suiDatepicker
          [pickerMode]="mode"
          [pickerMaxDate]="max"
          placeholder="Date of registration"
          type="text"
          formControlName="dateOfRegistration"
        />
        <app-field-error-display
          [displayError]="isFieldValid('dateOfRegistration')"
          errorMsg="Please enter date of registration"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('tinNumber')">
        <label>Tax Identification Number</label>
        <input
          formControlName="tinNumber"
          type="text"
          placeholder="Tax Identification Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tinNumber')"
          errorMsg="Please enter phone number"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('ownershipType')">
        <label>Ownership Type</label>
        <sui-select
          class="selection"
          formControlName="ownershipType"
          [options]="ownershipTypeData"
          labelField="optionName"
          valueField="optionId"
          #select
        >
          <sui-select-option
            *ngFor="let option of select.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-select>

        <app-field-error-display
          [displayError]="isFieldValid('ownershipType')"
          errorMsg="Please select department"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('companyType')">
        <label>Company Type</label>
        <sui-select
          class="selection"
          formControlName="companyType"
          [options]="companyTypeData"
          labelField="optionName"
          valueField="optionId"
          #bizselect
        >
          <sui-select-option
            *ngFor="let optionData of bizselect.filteredOptions"
            [value]="optionData"
          >
          </sui-select-option>
        </sui-select>

        <app-field-error-display
          [displayError]="isFieldValid('companyType')"
          errorMsg="Please select department"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
